import { type BadgeProps } from "@/components/ui/badge";
import { type TopicStatus } from "@/lib/api";

/** Friendly status pill per topic status, shared by the dashboard card and the detail dialog. */
export const STATUS_META: Record<
  TopicStatus,
  { label: string; variant: BadgeProps["variant"]; className?: string }
> = {
  active: {
    label: "Live",
    variant: "outline",
    className: "border-emerald-500/40 text-emerald-600 dark:text-emerald-400",
  },
  registered: {
    label: "Ready",
    variant: "outline",
    className: "border-amber-500/40 text-amber-600 dark:text-amber-400",
  },
  resolved: {
    label: "Resolved",
    variant: "outline",
    className: "border-emerald-500/30 text-emerald-700 dark:text-emerald-500",
  },
  closed: { label: "Closed", variant: "secondary" },
};

export function statusMeta(status: TopicStatus) {
  return (
    STATUS_META[status] ?? {
      label: status,
      variant: "outline" as BadgeProps["variant"],
    }
  );
}
